// extracted by mini-css-extract-plugin
export default {"img":"PasswordChangeForm_img__2vqJf","avt":"PasswordChangeForm_avt__dAvrY","eyeIcon":"PasswordChangeForm_eyeIcon__eiVKq"};